interface RequestData {
    url: string;
    request?: RequestInit;
    response?: Response;
}

export class HttpError extends Error {
    constructor(public message: string, public payload: RequestData) {
        super(message);
    }
}